export default "__VITE_ASSET__12cb5d47__"